import { Fragment, ReactNode } from 'react';
import cls from 'classnames';

import Heading from '@/common/components/Heading/Heading';
import Modal, { CENTER } from '@/common/components/Modal/Modal';

import styles from './BaseGlobalAccessModal.module.css';

export interface GlobalAccessModalProps {
  bottom?: ReactNode;
  disableClose?: boolean;
  isOpen: boolean;
  leftColumn: ReactNode;
  leftColumnTitle?: ReactNode;
  onClose: () => void;
  rightColumn?: ReactNode;
  rightColumnTitle?: ReactNode;
  title: ReactNode;
}

function BaseGlobalAccessModal(props: GlobalAccessModalProps) {
  const {
    bottom,
    disableClose = false,
    isOpen,
    leftColumn,
    leftColumnTitle,
    onClose,
    rightColumn,
    rightColumnTitle,
    title,
  } = props;

  return (
    <Modal disableClose={disableClose} isShowed={isOpen} onClose={onClose} position={CENTER} title={title}>
      <div>
        <div className={styles.columns}>
          <div className={cls(styles.columnWrapper, styles.leftColumnWrapper)}>
            <div className={styles.column}>
              {leftColumnTitle && (
                <Heading appearance="h3" className={styles.columnTitle}>
                  {leftColumnTitle}
                </Heading>
              )}

              {leftColumn}
            </div>
          </div>

          {rightColumn && (
            <Fragment>
              <div className={styles.separator} />

              <div className={cls(styles.columnWrapper, styles.rightColumnWrapper)}>
                <div className={styles.column}>
                  {rightColumnTitle && (
                    <Heading appearance="h3" className={styles.columnTitle}>
                      {rightColumnTitle}
                    </Heading>
                  )}

                  {rightColumn}
                </div>
              </div>
            </Fragment>
          )}
        </div>

        {bottom}
      </div>
    </Modal>
  );
}

export default BaseGlobalAccessModal;
